import { Component, inject } from "@angular/core";
import { RouterModule, RouterOutlet } from "@angular/router";
import { MatSidenavModule } from "@angular/material/sidenav";
import { CommonModule } from "@angular/common";
import { CoreService } from "../../../../../shared/src/lib/services/core.service";
import { AppSettings } from "../../app.config";
import { FooterComponent } from "../../components/footer/footer.component";

@Component({
    selector: "app-blank",
    templateUrl: "./blank.component.html",
    imports: [
        RouterModule,
        RouterOutlet,
        MatSidenavModule,
        CommonModule,
        FooterComponent,
    ],
    styleUrls: []
})
export class BlankComponent {
  settings = inject(CoreService);
  private htmlElement!: HTMLHtmlElement;

  options = this.settings.getOptions();

  constructor() {
    this.htmlElement = document.querySelector("html")!;
    // Initialize project theme with options
    this.receiveOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === "dark") {
      this.htmlElement.classList.add("dark-theme");
      this.htmlElement.classList.remove("light-theme");
    } else {
      this.htmlElement.classList.remove("dark-theme");
      this.htmlElement.classList.add("light-theme");
    }
  }
}
